export const Title = "超强伟业";
export const Keywords = "";
export const Description = "";

export const CDN = "https://cdn.suplaserai.com";
export const HomePage = "https://www.suplaserai.com/#/index";

export const appID = "wx1a937fa028ad70f4";

export const LegalLinks = {
    userAgreement: "#/setting/agreement",
    privacyPolicy: "#/setting/privacy",
    openSourceNotice: "#/setting/open-source",
};

export const SupportMiniProgram = {
    appId: "wxcbf3c7d0d5f1392d",
    path: "/pages/cusCol/cusCol?cusColId=128",
    envVersion: "release",
    extraData: {},
};

export const FuyanMiniProgram = {
    appId: "wxdfe692c1f5c9d626",
    path: `/pages/com/com?from=${appID}`,
    envVersion: "release",
    extraData: {},
};

export const SupportWebsite = "https://rx-planet.com";

export const AfterSaleEvaluateMiniProgram = {
    appId: "wxcbf3c7d0d5f1392d",
    path: "/pages/cusCol/cusCol?cusColId=281",
    envVersion: "release",
    extraData: {},
};

export default {
    Title,
    Keywords,
    Description,
    CDN,
    HomePage,
    appID,
    LegalLinks,
    SupportMiniProgram,
    FuyanMiniProgram,
    SupportWebsite,
    AfterSaleEvaluateMiniProgram,
};
